import React from "react";
import { Link, useParams } from "react-router-dom";
import SectionLayout from "@/pages/SectionLayout";

/**
 * RepositoryIdea — placeholder until copy is provided.
 * Visually identical to a manifesto-style panel.
 */
const RepositoryIdea = () => {
  const { id } = useParams();
  const safeId = (id || "").toString().slice(0, 6);

  return (
    <SectionLayout>
      <h2
        className="glass-panel__title glass-panel__title--lower"
        data-testid="section-title"
      >
        idea {safeId}
      </h2>
      <p
        className="glass-panel__body glass-panel__body--muted"
        data-testid="section-body"
      >
        Copy in preparation. Send the words and I&apos;ll lay them inside this
        glass.
      </p>
      <div className="glass-panel__nav">
        <Link to="/repository" className="glass-panel__btn" data-testid="btn-back">
          Repository
        </Link>
        <Link
          to="/"
          className="glass-panel__btn glass-panel__btn--right"
          data-testid="btn-home"
        >
          Home
        </Link>
      </div>
    </SectionLayout>
  );
};

export default RepositoryIdea;
